import React from 'react';

// Use individual imports for MUI components
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

// Styled components
const LoadingContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  textAlign: 'center',
  backgroundColor: theme.palette.background.default,
}));

const Logo = styled('img')({
  width: '150px',
  marginBottom: '20px',
  animation: 'pulse 2s infinite',
  '@keyframes pulse': {
    '0%': {
      opacity: 0.6,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0.6,
    },
  },
});

const LoadingScreen = () => {
  return (
    <LoadingContainer maxWidth="sm">
      <Logo 
        src="/logo.png" 
        alt="Utility Audit Pro" 
        onError={(e) => {
          // Fallback if logo image fails to load
          e.target.style.display = 'none';
        }}
      />
      
      <Typography variant="h5" gutterBottom color="primary">
        Utility Audit Pro
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
        <CircularProgress size={50} thickness={4} sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          Loading your dashboard...
        </Typography>
      </Box>
    </LoadingContainer>
  );
};

export default LoadingScreen;